import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Box,
    Button, Typography, List, ListItem, ListItemIcon, Link, IconButton
} from '@mui/material';
import { CheckCircle, Help, Close } from '@material-ui/icons'; // Added Close icon

const VerificationDialog = ({ open, onClose, onVerify }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{
                textAlign: 'center',
                color: '#FF6900',
                fontWeight: 'bold',
                fontSize: '1.5rem',
                pt: 3,
                position: 'relative' // Added for positioning the close button
            }}>
                Verification Required
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 16,
                        top: 16,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ px: 4, py: 2 }}>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    To ensure the security and legitimacy of our services, we require a valid copy of your
                    personal ID or business registration ID.<br/>
                    Why this is important:
                </Typography>

                <Box component="ul" sx={{
                    pl: 2,
                    mb: 3,
                    '& li': {
                        mb: 1,
                        pl: 1
                    }
                }}>
                    <Box component="li">
                        <Typography>
                            <strong>Identity Verification:</strong> Confirms that you are who you say you are.
                        </Typography>
                    </Box>
                    <Box component="li">
                        <Typography>
                            <strong>Compliance:</strong> Meets legal and regulatory requirements for operating our services.
                        </Typography>
                    </Box>
                    <Box component="li">
                        <Typography>
                            <strong>Trust & Safety:</strong> Builds a trusted environment for all users and partners.
                        </Typography>
                    </Box>
                </Box>

                <Typography variant="body1" sx={{ mb: 3 }}>
                    Your information will be kept confidential and secure, and used solely for verification
                    purposes in accordance with our <Link
                    href="https://www.poweredbydq.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        textDecoration: 'underline',
                        fontWeight: 'bold'
                    }}
                >
                    privacy policy
                </Link>.
                </Typography>

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1
                }}>
                    <Typography variant="body1" >
                        Need help? <a href="mailto:contact@dqforall.com">contact@dqforall.com</a>.
                    </Typography>
                </Box>
            </DialogContent>

        </Dialog>
    );
};

export default VerificationDialog;